import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Paper,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import React from "react";

import { useAppContext } from "src/hooks";
import NoTasksFound from "src/pages/dashboard/components/NoTasksFound";

import RecurringEventCard from "./RecurringEventCard";
import DashboardTaskCard from "src/pages/dashboard/components/DaashboardTaskCard";

export default function DayCalendar({
  events,
  // handleClick,
  currentDate,
  loading,
  recurringEvents,
}) {
  console.log(recurringEvents);
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const handleSortDate = (events) => {
    const startDate = moment(currentDate.start_date).format("YYYY-MM-DD");
    const endDate = moment(currentDate.end_date).format("YYYY-MM-DD");

    const filteredEvents = events.filter((event) => {
      const eventStartDate = moment.utc(event.start).format("YYYY-MM-DD");
      return (
        moment(eventStartDate).isSameOrAfter(startDate) &&
        moment(eventStartDate).isSameOrBefore(endDate)
      );
    });

    return filteredEvents;
  };

  const handleSortDateforEvents = (recurringEvents) => {
    const startDate = moment(currentDate.start_date).format("YYYY-MM-DD");
    const endDate = moment(currentDate.end_date).format("YYYY-MM-DD");

    const recurringFilteredEvents = recurringEvents.filter((item) => {
      const eventStartDate = moment.utc(item.start).format("YYYY-MM-DD");
      return (
        moment(eventStartDate).isSameOrAfter(startDate) &&
        moment(eventStartDate).isSameOrBefore(endDate)
      );
    });

    return recurringFilteredEvents;
  };

  const filteredEvents = handleSortDate(events);
  const recurringFilteredEvents = handleSortDateforEvents(recurringEvents);

  return (
    <>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="80vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        <div className="row m-2">
          {(filteredEvents.length > 0 ||
            recurringFilteredEvents.length > 0) && (
            <Card>
              <CardContent sx={{ padding: "24px 0px" }}>
                {filteredEvents.map((event) => (
                  <div className={is_mobile_view ? "px-0 py-1" : "px-3 py-1"} key={event.id}>
                    <DashboardTaskCard
                      task={event.more}
                      // onTaskClick={handleClick}
                      showIcon={true}
                    />
                  </div>
                ))}
                {/* ===================== recurring events =================== */}
                {recurringFilteredEvents.map((event, index) => (
                  <div className={is_mobile_view ? "px-0 py-1" : "px-3 py-1"} key={index}>
                    <RecurringEventCard event={event} />
                  </div>
                ))}
              </CardContent>
            </Card>
          )}

          {filteredEvents.length === 0 &&
            recurringFilteredEvents.length === 0 && (
              <div className="d-flex justify-content-center align-items-center">
                <NoTasksFound />
              </div>
            )}
        </div>
      )}
    </>
  );
}
